import "../styles/main.css";
import { initPageLoader } from "./page-loader";
import { initSmoothScroll } from "./smooth-scroll";
import { initHeader } from "./nav";
import { initReveals } from "./reveal";
import { initHeroCanvas } from "./hero-canvas";
import { initMagnetic } from "./magnetic";
import { initCounters } from "./counters";
import { initTabs } from "./tabs";
import { initChatDemo } from "./chat-demo";
import { initGuideToc } from "./guide";
import { initContactForm } from "./contact";
import { initCarousel } from "./carousel";
import { initPricingCalculator } from "./pricing";
import { initFlowCanvas } from "./flow-canvas";

const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

initPageLoader();
initHeader();
initTabs();
initChatDemo();
initGuideToc();
initContactForm();
initCarousel();
initPricingCalculator();
initFlowCanvas();

if (!reduced) {
  initSmoothScroll();
  initReveals();
  initHeroCanvas();
  initMagnetic();
  initCounters();
} else {
  document.querySelectorAll("[data-reveal]").forEach((el) => el.classList.add("is-in"));
}

const progress = document.querySelector(".progress-bar");
const glow = document.querySelector(".cursor-glow");

window.addEventListener(
  "scroll",
  () => {
    if (!progress) return;
    const max = document.documentElement.scrollHeight - window.innerHeight;
    const value = max > 0 ? window.scrollY / max : 0;
    progress.style.width = `${value * 100}%`;
  },
  { passive: true }
);

if (glow && !reduced && window.matchMedia("(pointer: fine)").matches) {
  window.addEventListener("pointermove", (event) => {
    glow.style.left = `${event.clientX}px`;
    glow.style.top = `${event.clientY}px`;
  });
}
